import TabController from '../helpers/TabController';
import { SELECTORS, EVENTS } from '../config/constants';

export default function () {
  const tabListElems = document.querySelectorAll(SELECTORS.TAB.LIST);

  if (tabListElems) {
    window.addEventListener('load', () => {
      handleTabs(tabListElems);
    });
  }

  window.addEventListener(EVENTS.AJAX_RELOAD, function ({ target }) {
    if (!target) {
      return;
    }

    const isTargetTabList = target.classList.contains(SELECTORS.TAB.LIST);

    if (!isTargetTabList) {
      return;
    }

    const activeItem = target.querySelector(SELECTORS.TAB.LIST_ITEM_ACTIVE);

    initTabController({ tabListEl: target, activeItem });
  });
}

function handleTabs(tabListElems) {
  tabListElems.forEach((tabListEl) => {
    const activeItem = document.querySelector(SELECTORS.TAB.LIST_ITEM_ACTIVE);
    if(activeItem) {
      initTabController({ tabListEl, activeItem});
    } else {
      initTabController({ tabListEl});
    }
  });
}

function initTabController({ tabListEl, activeItem }) {
  new TabController(tabListEl).init(activeItem);
}
